<template>
  <v-container fluid>
    <base-material-card color="primary" icon="mdi-file-compare" inline class="px-5 py-3">
      <template v-slot:after-heading>
        <div>
          BDGD
          <v-progress-circular v-if="loading" size="20" indeterminate color="rgba(0, 0, 0, 0.87)" />
          <span v-else>
            {{ bdgdVersao.ordinaria ? 'Ordinária' : '' }}
            {{ bdgdVersao.data_registro | formatToMonth }} v{{ bdgdVersao.versao }}
          </span>
          x INDQUAL
        </div>
      </template>
      <v-row>
        <v-col cols="12" class="d-flex flex-row-reverse">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="mt-n10" v-bind="attrs" v-on="on">
                <v-btn
                  icon
                  color="black"
                  :loading="loadingDownloadArquivoResultado"
                  v-bind="attrs"
                  @click="downloadArquivoResultado"
                  v-on="on"
                >
                  <v-icon size="22">mdi-download</v-icon>
                </v-btn>
              </div>
            </template>
            Baixar resultados INDQUAL
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="d-flex flex-row-reverse">
          <router-link to="/geracao-bdgd/validacoes-indqual/painel-unificado" class="ml-4">Painel Unificado INDQUAL</router-link>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-tabs v-model="currentItem" fixed-tabs>
            <v-tab href="#tab-resumo" class="primary--text">Resumo</v-tab>
            <v-tab href="#tab-importacoes" class="primary--text">Importações INDQUAL</v-tab>
            <v-tab v-for="item in items" :key="item.id" :href="'#tab-' + item.id" class="primary--text">
              {{ item.nome }}
            </v-tab>
            <v-menu v-if="more.length" bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn text class="align-self-center mr-4 primary--text" v-bind="attrs" v-on="on">
                  mais ({{ more.length }})
                  <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list class="grey lighten-3">
                <v-list-item v-for="item in more" :key="item.id" @click="addItem(item)">
                  {{ item.nome }}
                </v-list-item>
              </v-list>
            </v-menu>
          </v-tabs>
          <v-tabs-items v-model="currentItem">
            <v-tab-item value="tab-resumo">
              <v-row class="mt-6">
                <v-col cols="12" class="pb-0">
                  <v-alert text color="info" class="mb-0">
                    <v-row align="center" no-gutters>
                      <v-col class="grow">
                        Esta aba apresenta um resumo consolidado das quatro principais validações, exibindo de forma sintética os
                        respectivos resultados. Ela funciona como um painel central de acompanhamento, permitindo ao usuário
                        identificar rapidamente pontos de aderência e eventuais divergências críticas entre as validações cruzadas
                        realizadas no módulo.
                      </v-col>
                    </v-row>
                  </v-alert>
                </v-col>
                <v-col cols="12">
                  <v-progress-circular v-if="loading" size="20" indeterminate color="rgba(0, 0, 0, 0.87)" />
                  <span v-else>
                    <resumo-validacoes :bdgdVersao="bdgdVersao" :metodologiasAneelAtivas="metodologiasAneelAtivas" />
                  </span>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item value="tab-importacoes">
              <v-row class="mt-6">
                <v-col cols="12">
                  <v-alert text color="info">
                    <v-row align="center" no-gutters>
                      <v-col class="grow">
                        Esta aba mostra o histórico de importações feitas tanto do INDQUAL quanto da BDGD.
                      </v-col>
                    </v-row>
                  </v-alert>
                </v-col>
                <v-col cols="6">
                  <tabela-resumo-importacoes-indicadores-dec-fec-nuc class="mb-2" :bdgdVersao="bdgdVersao" />
                </v-col>
                <v-col cols="6">
                  <tabela-resumo-importacoes-entidades-bdgd class="mb-2" :bdgdVersao="bdgdVersao" />
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item
              v-for="metodologiaAneel in items.concat(more)"
              :key="metodologiaAneel.id"
              :value="'tab-' + metodologiaAneel.id"
            >
              <v-row class="mt-4">
                <v-col cols="12">
                  <v-alert text color="info">
                    <v-row align="center" no-gutters>
                      <v-col class="grow">
                        {{ metodologiaAneel.descricao }}
                      </v-col>
                    </v-row>
                  </v-alert>
                  <v-alert text color="info" class="mb-0">
                    <v-row align="center" no-gutters>
                      <v-col class="grow pb-0">
                        {{ documentacaoMetodologia[metodologiaAneel.codigo] }}
                      </v-col>
                    </v-row>
                  </v-alert>
                </v-col>
              </v-row>
              <v-row class="mt-4" align="center">
                <v-col cols="12">
                  <component
                    :is="getFormExecucaoMetodologia(metodologiaAneel)"
                    :metodologiaAneel="metodologiaAneel"
                    :bdgdVersao="bdgdVersao"
                    @metodologiaExecutada="processaMetodologiaExecutada(metodologiaAneel)"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col class="mt-4" cols="12">
                  <v-tabs v-model="tabsLevel2[metodologiaAneel.id]" fixed-tabs>
                    <v-tab v-if="metodologiaAneel.tem_teste_dec_fec" href="#tab-dec-fec" class="primary--text">DEC/FEC</v-tab>
                    <v-tab v-if="metodologiaAneel.tem_teste_nuc" href="#tab-nuc" class="primary--text">NUC</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tabsLevel2[metodologiaAneel.id]">
                    <v-tab-item value="tab-dec-fec">
                      <v-progress-circular v-if="loading" size="20" indeterminate color="rgba(0, 0, 0, 0.87)" />
                      <resultado-validacao-dec-fec
                        v-else
                        :ref="`resultadoValidacaoDecFec${metodologiaAneel.codigo}`"
                        :metodologia-aneel="metodologiaAneel"
                        :bdgdVersao="bdgdVersao"
                      />
                    </v-tab-item>
                    <v-tab-item v-if="metodologiaAneel.tem_teste_nuc" value="tab-nuc">
                      <v-progress-circular v-if="loading" size="20" indeterminate color="rgba(0, 0, 0, 0.87)" />
                      <resultado-validacao-nuc
                        v-else
                        :ref="`resultadoValidacaoNuc${metodologiaAneel.codigo}`"
                        :metodologia-aneel="metodologiaAneel"
                        :bdgdVersao="bdgdVersao"
                      />
                    </v-tab-item>
                  </v-tabs-items>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
  import dayjs from 'dayjs';
  import ValidacoesIndqualService from '@/services/ValidacoesIndqualService';
  import ResumoValidacoes from '@/components/geracao-bdgd/indqual/ResumoValidacoes.vue';
  import TabelaResumoImportacoesIndicadoresDecFecNuc from '@/components/geracao-bdgd/indqual/resumos-importacoes/TabelaResumoImportacoesIndicadoresDecFecNuc.vue';
  import TabelaResumoImportacoesEntidadesBdgd from '@/components/geracao-bdgd/indqual/resumos-importacoes/TabelaResumoImportacoesEntidadesBdgd.vue';
  import ResultadoValidacaoDecFec from '@/components/geracao-bdgd/indqual/ResultadoValidacaoDecFec.vue';
  import ResultadoValidacaoNuc from '@/components/geracao-bdgd/indqual/ResultadoValidacaoNuc.vue';
  import FormExecucaoMetodologia1 from '@/components/geracao-bdgd/indqual/FormExecucaoMetodologia1.vue';
  import FormExecucaoMetodologia1a from '@/components/geracao-bdgd/indqual/FormExecucaoMetodologia1a.vue';
  import FormExecucaoMetodologia1b from '@/components/geracao-bdgd/indqual/FormExecucaoMetodologia1b.vue';
  import FormExecucaoMetodologia2 from '@/components/geracao-bdgd/indqual/FormExecucaoMetodologia2.vue';
  import FormExecucaoMetodologia3 from '@/components/geracao-bdgd/indqual/FormExecucaoMetodologia3.vue';
  import FormExecucaoMetodologia4 from '@/components/geracao-bdgd/indqual/FormExecucaoMetodologia4.vue';
  import FormExecucaoMetodologia5 from '@/components/geracao-bdgd/indqual/FormExecucaoMetodologia5.vue';
  import FormExecucaoMetodologia6 from '@/components/geracao-bdgd/indqual/FormExecucaoMetodologia6.vue';
  import profilePermissionsMixin from '@/mixins/profilePermissionsMixin';
  import refreshDataMixins from '@/mixins/refreshDataMixins';

  export default {
    name: 'ValidacoesIndqual',
    components: {
      ResumoValidacoes,
      TabelaResumoImportacoesIndicadoresDecFecNuc,
      TabelaResumoImportacoesEntidadesBdgd,
      ResultadoValidacaoDecFec,
      ResultadoValidacaoNuc,
      FormExecucaoMetodologia1,
      FormExecucaoMetodologia1a,
      FormExecucaoMetodologia1b,
      FormExecucaoMetodologia2,
      FormExecucaoMetodologia3,
      FormExecucaoMetodologia4,
      FormExecucaoMetodologia5,
      FormExecucaoMetodologia6
    },
    mixins: [profilePermissionsMixin, refreshDataMixins],
    data: () => ({
      currentItem: 'tab-resumo',
      items: [],
      more: [],
      numAbasVisiveis: 3,
      tabsLevel2: {},
      loading: false,
      loadingDownloadArquivoResultado: false,
      metodologiasAneelAtivas: [],
      documentacaoMetodologia: {
        3: `Esta aba serve para validar se a soma dos indicadores
        individuais de duração e frequência de interrupção (DIC e FIC) das unidades
        consumidoras está em conformidade com os indicadores de conjunto (DEC e
        FEC). O sistema verifica se a diferença entre esses dados respeita o limite
        regulatório de 5%.`,
        4: `Esta aba trata-se de uma funcionalidade específica para validar o
        preenchimento de DIC e FIC em unidades que possuem Micro e Minigeração 
        Distribuída (MMGD). Ela garante que as Unidades Consumidoras e Geradoras
        de um mesmo ponto de acesso tenham dados de continuidade consistentes,
        com um limite de tolerância mais rígido, de 2%.`,
        5: `Esta aba serve para cruzar o Número de Unidades
        Consumidoras (NUC) declarado por conjunto na BDGD com o histórico dos
        últimos 12 meses presentes no sistema de qualidade. O objetivo é assegurar
        que a base geográfica não tenha uma variação superior a 5% em relação ao
        mercado declarado em dezembro.`,
        6: `Verifica a taxa de variação do número de
        Unidades Consumidoras (NUC) declaradas na BDGD em comparação com o
        INDQUAL. O critério regulatório da ANEEL aplica o limite de 5% na comparação
        do mês de dezembro, enquanto o sistema monitora a variação ao longo dos
        últimos 12 meses para assegurar a consistência do comportamento do
        mercado ao longo do ano.`
      }
    }),
    computed: {
      bdgdVersao() {
        return this.$store.getters.getUserSelectedCompanyBdgdVersion;
      }
    },
    mounted() {
      this.getMetodologiasAneelAtivas();
    },
    methods: {
      addItem(item) {
        const removed = this.items.splice(0, 1);
        const itemIndex = this.more.findIndex((el) => el.codigo === item.codigo);
        this.items.push(...this.more.splice(itemIndex, 1));
        this.more.push(...removed);
        this.$nextTick(() => {
          this.currentItem = 'tab-' + item.id;
        });
      },
      getMetodologiasAneelAtivas() {
        this.loading = true;
        ValidacoesIndqualService.getMetodologiasAneelAtivas()
          .then((response) => {
            this.metodologiasAneelAtivas = response.data;
            this.items = this.metodologiasAneelAtivas.slice(0, this.numAbasVisiveis);
            this.more = this.metodologiasAneelAtivas.slice(this.numAbasVisiveis, this.metodologiasAneelAtivas.length);
          })
          .catch((err) => {
            console.log('Erro: ', err);
            this.$toast.error('Erro ao buscar as metodologias ANEEL ativas no sistema.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      },
      getFormExecucaoMetodologia(metodologiaAneel) {
        return `form-execucao-metodologia-${metodologiaAneel.codigo.toLowerCase()}`;
      },
      processaMetodologiaExecutada(metodologiaAneel) {
        const resultadoValidacaoDecFec = this.$refs[`resultadoValidacaoDecFec${metodologiaAneel.codigo}`];
        const resultadoValidacaoNuc = this.$refs[`resultadoValidacaoNuc${metodologiaAneel.codigo}`];
        if (resultadoValidacaoDecFec && resultadoValidacaoDecFec[0]) {
          resultadoValidacaoDecFec[0].getResultadoExecucaoMetodologia();
        }
        if (resultadoValidacaoNuc && resultadoValidacaoNuc[0]) {
          resultadoValidacaoNuc[0].getResultadoExecucaoMetodologia();
        }
      },
      downloadArquivoResultado() {
        this.loadingDownloadArquivoResultado = true;
        ValidacoesIndqualService.downloadArquivoResultado(this.bdgdVersao.id, {
          timeout: 60 * 60 * 1000
        })
          .then((res) => {
            const timestamp = dayjs(new Date()).format('YYYYMMDDHHmm');
            const arquivo = `resultado-metodologias-indqual-${timestamp}.xlsx`;
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', arquivo);
            document.body.appendChild(link);
            link.click();
          })
          .catch(() => {
            this.$toast.error('Falha no download do arquivo resultado.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loadingDownloadArquivoResultado = false));
      }
    }
  };
</script>

<style>
  .table-indqual-result table thead tr th,
  .table-indqual-result table tbody tr td,
  .table-indqual-result table tfoot tr td {
    font-size: 12px;
    white-space: nowrap;
    padding: 0px 8px !important;
  }
  .table-indqual-result table thead tr th {
    font-weight: 500;
  }
  .zebra1 {
    background-color: #fafafa;
  }
  .zebra2 {
    background-color: #f9fbe7;
  }
  .status-indqual-ok {
    font-size: 8px !important;
    background-color: #c6efce;
    color: #006100;
  }
  .status-indqual-erro {
    font-size: 8px !important;
    background: #ffc7ce;
    color: #9c0006;
  }
  .status-indqual-alerta {
    font-size: 8px !important;
    background: #ffeb9c;
    color: #9c5700;
  }
</style>
